<template>
    <div class="modal" :class="{ 'is-active': show }" v-if="show">
      <div class="modal-background"></div>

      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Start Transaction</p>
        </header>

        <section class="modal-card-body" v-show="!showSuccess">
          <b-field label="Invite Carriers">
            <contact-list contact-type="carrier" v-model="carriers" />
          </b-field>

          <b-field label="Additional Contacts">
            <p class="content">
              You can invite additional contacts that will be updated about changes to the ETA. Good contacts to add are the recipient of the freight as well as other involved parties, but also additional people at the shipper company whom you think might benefit from knowledge of where the freight is.
            </p>
          </b-field>
          <b-field >
            <contact-list contact-type="contact" v-model="additionalContacts" />
          </b-field>
        </section>

        <section class="modal-card-body" v-show="showSuccess">
          <h1 class="title">Congratulations!</h1>
          <p class="content">
            Your new load has been setup and we have notified your carrier.
          </p>
          <p class="content">
            You will receive an email as soon asy our carrier has accepted the load.
          </p>

          <ul>
            <li>
              <router-link @click.native="hide" :to="{ 'name': 'create-transaction'}" class="button is-primary">Setup another transaction</router-link>
            </li>
            <li>
              <router-link @click.native="hide" :to="{ 'name': 'dashboard'}" >Return to the dashboard</router-link>
            </li>
          </ul>
        </section>

        <footer class="modal-card-foot" v-show="!showSuccess">
          <button type="button" class="button" @click="hide" :disable="isSaving">Cancel</button>
          <button type="button"
                  class="button is-primary"
                  :class="{ 'is-loading': isSaving }"
                  @click="startTransaction"
                  :disabled="isSaving || !canSendInvite">
            Send Invitations
          </button>
        </footer>
      </div>

    </div>
</template>

<script>
import ContactList from '@/components/ContactFrom-Multiple'
import InviteApi from '@/api-interface/invite'
import { isEmpty } from 'lodash-es'

export default {
  name: 'StartTransaction',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    transactionKey: {
      type: String
      // required: true
    }
  },

  data() {
    return {
      transactionInvites: [],
      isSaving: false,
      showSuccess: false,
      additionalContacts: [],
      carriers: []
    }
  },

  computed: {
    hasExistingCarrierInvites() {
      return this.transactionInvites.some((invite) => invite.inviteAccountType === 'carrier')
    },

    canSendInvite() {
      let canSend = true
      const totalCarriers = this.carriers.length

      // check that all carriers have either an email address or a phone number
      const validCarriers = this.carriers.filter((carrier) => {
        return !isEmpty(carrier.email) || carrier.phone > 0
      })

      if ((totalCarriers === 0 || validCarriers.length !== totalCarriers) && !this.hasExistingCarrierInvites) {
        canSend = false
      }

      return canSend
    }
  },

  components: {
    ContactList
  },

  methods: {
    hide() {
      this.$emit('update:show', false)
      this.showSuccess = false
    },

    async startTransaction() {
      this.isSaving = true
      const carriers = InviteApi.inviteCarrierToJobBulk({ jobKey: this.transactionKey, recipientList: this.carriers })
      const others = InviteApi.inviteRecipientToJobBulk({
        jobKey: this.transactionKey,
        recipientList: this.additionalContacts
      })

      try {
        await Promise.all([carriers, others])
      } catch (error) {
        console.log('There was an error calling the invite service', error)
      } finally {
        this.isSaving = false
        this.showSuccess = true
        // this.$router.push({ name: 'transaction-success' })
      }
    }
  },

  watch: {
    async show() {
      if (this.show) {
        this.transactionInvites = await InviteApi.companyJobInviteList({ companyJobKey: this.transactionKey }) // await TransactionsApi.getByKey(this.transactionKey)
      }
    }
  }
}
</script>

<style scoped>
li {
  padding: 10px 0;
}
</style>
